import { useTranslation } from 'react-i18next'

export function ShortDisclaimer() {
  const { t } = useTranslation()
  return (
    <p className="mt-2 text-[10px] leading-relaxed text-neutral-600">
      {t('compliance.shortDisclaimer')}
    </p>
  )
}

export function AITransparencyNotice() {
  const { t } = useTranslation()
  return (
    <div className="mt-3 flex items-start gap-2 rounded-xl border border-neutral-800 bg-neutral-900 p-3">
      <span className="mt-0.5 shrink-0 font-mono text-[10px] uppercase tracking-widest text-neutral-500">
        AI
      </span>
      <p className="text-[10px] leading-relaxed text-neutral-500">{t('compliance.aiTransparency')}</p>
    </div>
  )
}

export function MealWellnessDisclaimer() {
  const { t } = useTranslation()
  return (
    <p className="mt-1 text-[10px] text-neutral-600">{t('compliance.mealDisclaimer')}</p>
  )
}

type FullDisclaimerModalProps = {
  onAccept: () => void
}

export function FullDisclaimerModal({ onAccept }: FullDisclaimerModalProps) {
  const { t } = useTranslation()

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/60 backdrop-blur-sm">
      <div className="w-full max-w-lg rounded-t-3xl border-t border-neutral-800 bg-neutral-950 p-6 pb-10">
        <div className="mx-auto mb-6 h-1 w-10 rounded-full bg-neutral-700" />
        <h2 className="mb-3 text-lg font-semibold text-white">{t('compliance.beforeYouStart')}</h2>
        <p className="mb-6 text-sm leading-relaxed text-neutral-400">{t('compliance.fullDisclaimer')}</p>
        <div className="space-y-2">
          <p className="text-center text-[11px] text-neutral-600">
            {t('compliance.confirmHealthyAdult')}
          </p>
          <button
            type="button"
            onClick={onAccept}
            className="w-full rounded-2xl bg-kilo-accent py-3.5 text-sm font-semibold text-black"
          >
            {t('compliance.acceptDisclaimer')}
          </button>
        </div>
      </div>
    </div>
  )
}

export function DataUsageNotice() {
  const { t } = useTranslation()
  return (
    <div className="rounded-2xl border border-neutral-800 bg-neutral-900 p-4">
      <p className="mb-2 text-[10px] uppercase tracking-widest text-neutral-500">{t('compliance.dataPrivacy')}</p>
      <p className="text-xs leading-relaxed text-neutral-400">{t('compliance.dataUsage')}</p>
    </div>
  )
}

type LegalInfoModalProps = {
  title: string
  body: string
  onClose: () => void
}

export function LegalInfoModal({ title, body, onClose }: LegalInfoModalProps) {
  const { t } = useTranslation()

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/60 backdrop-blur-sm">
      <div className="max-h-[85vh] w-full max-w-lg overflow-y-auto rounded-t-3xl border-t border-neutral-800 bg-neutral-950 p-6 pb-10">
        <div className="mx-auto mb-6 h-1 w-10 rounded-full bg-neutral-700" />
        <h2 className="mb-3 text-lg font-semibold text-white">{title}</h2>
        <p className="text-sm leading-relaxed text-neutral-400">{body}</p>
        <button
          type="button"
          onClick={onClose}
          className="mt-6 w-full rounded-2xl border border-neutral-700 bg-neutral-900 py-3 text-sm font-semibold text-white"
        >
          {t('common.close')}
        </button>
      </div>
    </div>
  )
}
